






































































































































































































































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator'
import dayjs from 'dayjs'
import dayjsID from 'dayjs/locale/id'
import utc from 'dayjs/plugin/utc';
import IconCourier from '@/app/ui/assets/icon_motorcycle_front.vue'
import IconCancelTask from '@/app/ui/assets/icon_cancel_task.vue'
import DropdownSelect from '@/app/ui/components/DropdownSelect/index.vue'
import Button from '@/app/ui/components/Button/index.vue'
import ModalSuccess from '../../components/Modals/ModalSuccess.vue'
import ModalConfirmation from '../../components/Modals/ModalConfirmation.vue'
import ModalAction from '@/app/ui/components/Modal/ModalAction.vue'
import ModalInput from '../../components/Modals/ModalInput.vue'
import controller, {
  ReschedulePickupPayloadInterface,
} from '@/app/ui/controllers/ReschedulePickupController'
import {
  ReschedulePickupDetailV2,
  ReschedulePickupDetailVShipment
} from '@/domain/entities/ReschedulePickup'
import LoadingOverlay from '@/app/ui/components/LoadingOverlay/index.vue'
import { Utils } from '@/app/infrastructures/misc'
import IconProfile from '@/app/ui/assets/ics_f_profile.vue'
import IconPhoneBlack from '@/app/ui/assets/ics_f_phone.vue'
import IconLocationPin from '@/app/ui/assets/ics_f_location_pin.vue'
import IconWhatsApp from '@/app/ui/assets/ics_f_whatsapp.vue'
import IconClockFill from '@/app/ui/assets/clock2.vue'
import IconCalendar2 from '@/app/ui/assets/icon_calendar_black.vue'
import DataTableV2 from '@/app/ui/components/DataTableV2/index.vue'
import {
  DataObject,
  HeaderObject,
  SortValueObject,
} from '@/app/ui/components/DataTableV2/type'
import PickupController, {
  DropdownValue,
} from '@/app/ui/controllers/PickupController'
import ScheduleAssigneCourier from '@/app/ui/views/Pickup/components/ScheduleAssigneCourier/index.vue'
import { EnumActions } from '@/app/infrastructures/misc/Constants/pickup'
import PaginationNav from '@/app/ui/components/PaginationNav/index.vue'
import ImageViewer from '@/app/ui/components/ImageViewer/index.vue'
import Skeleton from '@/app/ui/components/Skeleton/index.vue'

dayjs.extend(utc);

@Component({
  components: {
    IconCourier,
    IconCancelTask,
    DropdownSelect,
    Button,
    ModalSuccess,
    ModalConfirmation,
    ModalAction,
    ModalInput,
    LoadingOverlay,
    IconLocationPin,
    IconProfile,
    IconPhoneBlack,
    IconWhatsApp,
    IconClockFill,
    IconCalendar2,
    DataTableV2,
    ScheduleAssigneCourier,
    PaginationNav,
    ImageViewer,
    Skeleton
  },
})
export default class RescheduleDetail extends Vue {
  controller = controller
  pickupController = PickupController
  EnumActions = EnumActions
  dataReschedulePickup: ReschedulePickupDetailV2 = new ReschedulePickupDetailV2()
  showModal = {
    confirm: false,
    success: false,
    connection: false,
    input: false
  }
  alreadySubmitted = false
  isAtBottom = false;
  observer: IntersectionObserver | null = null;
  isRejectProcess = false
  parameters = {
    page: 1,
    perPage: 10,
    sort: {
      name: '',
      direction: '' as string,
    },
  }
  modalInputValue = ''
  tableSlotNames = [
    '',
    'orderid',
    'producttype',
    'totalkoli'
  ]
  headers: HeaderObject[] = []
  tableData: DataObject[][] = []
  form: {
    courier: DropdownValue | undefined
    manualAssignDate: Date | undefined
    manualAssignHour: number
    manualAssignMinute: number
  } = {
    courier: undefined,
    manualAssignDate: undefined,
    manualAssignHour: 0,
    manualAssignMinute: 0,
  }
  isScheduleManualAssign = false
  assignSubmitting = false
  customMinutes = [0, 10, 20, 30, 40, 50]
  invoiceImage: string[] = []
  showImage = false
  imageSrc = ''
  indexOfImage = 0
  isAllData = false

  get courierOptions(): DropdownValue[] {
    return this.pickupController.courierData
  }

  get isCourierLoading(): boolean {
    return this.pickupController.isCourierLoading
  }

  public courierSearch = Utils.debounce((search: string) => {
    const q = search === '' ? undefined : search
    this.pickupController.getCourierList({
      perPage: 30,
      q,
      courierStatus: 'ACTIVE',
      driverType: 'KVP%3BPOS'
    })
  }, 500)

  get scheduleCourier(): Date | null {
    if (!this.form.manualAssignDate) return null
    const d = new Date(this.form.manualAssignDate.getTime())
    d.setHours(this.form.manualAssignHour, this.form.manualAssignMinute, 0, 0)
    return d
  }

  public onToggleScheduleManualAssign(active: boolean): void {
    this.isScheduleManualAssign = active
    if (!active) {
      this.form.manualAssignDate = undefined
    }
  }

  public onChangeManualAssignDate(value?: Date): void {
    if (value) {
      this.form.manualAssignDate = value
      this.form.manualAssignHour = value.getHours()
      this.form.manualAssignMinute = value.getMinutes()
    } else {
      this.form.manualAssignDate = undefined
    }
  }

  public onBack(): void {
    this.$router.push('/pickup/CRRNFD-v2/reschedule')
  }

  get disableSubmit(): boolean {
    return (
      this.assignSubmitting ||
      !this.form.courier ||
      (this.isScheduleManualAssign && !this.form.manualAssignDate)
    )
  }

  private async onApprove() {
    const payload: ReschedulePickupPayloadInterface = {
      shipmentId: this.dataReschedulePickup.shipmentId,
      courierId: (<DropdownValue>this.form.courier).value,
      rescheduledAt: dayjs(`${this.form.manualAssignDate}${this.form.manualAssignHour}${this.form.manualAssignMinute}`).format(
        'YYYY-MM-DD HH:mm:ss'
      ),
      timeZone: dayjs()
        .locale(dayjsID)
        .format('Z'),
    }

    const res = await controller.updateV2(payload)

    if(res.status === 200) {
      controller.requestApprove([this.$route.params.rescheduleId])
    }
  }

  private onActionModal(type: string): void {
    this.showModal.confirm = false
    if (type === EnumActions.SUBMIT && !this.isRejectProcess) {
      this.onApprove()
    } else if(type === EnumActions.SUBMIT && this.isRejectProcess) {
      this.onActionModalInput(EnumActions.SUBMIT)
    } else if(type === EnumActions.CANCEL && this.isRejectProcess) {
      this.showModal.input = true
      this.isRejectProcess = false
    }
  }

  private onActionModalInput(type: string): void {
    if(type === EnumActions.SUBMIT) {
      controller.requestReject({
        ids: [this.$route.params.rescheduleId],
        reason: this.modalInputValue
      })
      this.showModal.confirm = false
      this.modalInputValue = ''
    } else if(type === EnumActions.CANCEL) {
      this.showModal.input = false
    }
  }

  private onActionSuccess() {
    this.$router.push({ name: 'ListPickupCRRNFDReschedule_V2' })
    this.isRejectProcess = false
  }

  private onChangeModalInput(value: string) {
    this.modalInputValue = value
  }

  private onContinueReject() {
    this.showModal.input = false
    this.isRejectProcess = true
    this.showModal.confirm = true
  }

  get rescheduleId() {
    return this.$route.params.rescheduleId || ''
  }

  created(): void {
    this.initHeaders()
    this.loadDetail(true)
  }

  mounted(): void {
    this.pickupController.getCourierList({
      perPage: 30,
      courierStatus: 'ACTIVE',
      driverType: 'KVP%3BPOS'
    })

    const options = { root: null, threshold: 1.0 };
    this.observer = new IntersectionObserver(([entry]) => {
      this.isAtBottom = entry.isIntersecting;
    }, options);

    const bottomLimit = this.$refs.bottomLimit as Element;
    if (bottomLimit) this.observer.observe(bottomLimit);
  }

  get totalItems(): number {
    return this.dataReschedulePickup?.pagination?.totalItem ?? 0
  }

  get formatCourierRequestedAtDate() {
    return Utils.formatTimeZone(
      Utils.formatDateWithIDLocale(
        <string>this.dataReschedulePickup.courierRequestedAt,
        'DD MMM YYYY HH:mm Z',
      ),
    )
  }

  get formatApprovedAtDate() {
    return Utils.formatTimeZone(
      Utils.formatDateWithIDLocale(
        this.dataReschedulePickup?.approvedAt as string,
        'DD MMM YYYY HH:mm Z',
      ),
    )
  }

  get formatRejectedAtDate() {
    return Utils.formatTimeZone(
      Utils.formatDateWithIDLocale(
        this.dataReschedulePickup?.rejectedAt as string,
        'DD MMM YYYY HH:mm Z',
      ),
    )
  }

  get statusWording() {
    const wordings = {
      approved: "diterima",
      pending: "menunggu",
      rejected: "ditolak"
    }
    const statusApproval = (this.dataReschedulePickup?.statusApproval || "").toLowerCase() as keyof typeof wordings

    return statusApproval === "approved" || statusApproval === "rejected" ? wordings[statusApproval] : wordings.pending
  }

  get statusStyles() {
    const statuses = {
      approved: "text-green-2 bg-green-1",
      pending: "text-yellow-6 bg-yellow-1",
      rejected: "text-red-10 bg-red-9"
    }
    const statusApproval = (this.dataReschedulePickup?.statusApproval || "").toLowerCase() as keyof typeof statuses

    return statusApproval === "approved" || statusApproval === "rejected" ? statuses[statusApproval] : statuses.pending
  }

  buildNextCourierLine() {
    if ((!this.dataReschedulePickup.nextCourierId && this.dataReschedulePickup.nextCourierName)) return null
    const courierType = this.dataReschedulePickup.nextCourierType ? ` (${this.dataReschedulePickup.nextCourierType})` : ''
    return `[${this.dataReschedulePickup.nextCourierId || '—'}] ${this.dataReschedulePickup.nextCourierName || ''}${courierType}`.trim()
  }

  buildLastCourierLine() {
    if ((!this.dataReschedulePickup.courierId && this.dataReschedulePickup.courierName)) return '—'
    const courierType = this.dataReschedulePickup.courierType ? ` (${this.dataReschedulePickup.courierType})` : ''
    return `[${this.dataReschedulePickup.courierId || '—'}] ${this.dataReschedulePickup.courierName || ''}${courierType}`.trim()
  }

  get lastCourierLine(): string {
    return this.buildLastCourierLine()
  }

  buildNextCourierAgent() {
    const c = this.dataReschedulePickup
    if (!c || (!c.nextCourierAgentCode && !c.nextCourierAgentName)) {
      return null
    }

    const NextCourierAgentName = c.nextCourierAgentName ? ` ${c.nextCourierAgentName}` : ''
    const NextCourierAgentCode = c.nextCourierAgentCode ? ` [${c.nextCourierAgentCode}]` : ''
    return `${NextCourierAgentName}${NextCourierAgentCode}`.trim()
  }

  buildLastCourierAgent() {
    const c = this.dataReschedulePickup
    if (!c || (!c.courierAgentCode && !c.courierAgentName)) {
      return '—'
    }

    const courierAgentName = c.courierAgentName ? ` ${c.courierAgentName}` : ''
    const courierAgentCode = c.courierAgentCode ? ` [${c.courierAgentCode}]` : ''
    return `${courierAgentName}${courierAgentCode}`.trim()
  }

  get lastCourierLineAgent(): string {
    return this.buildLastCourierAgent()
  }

  get isTableLoading(): boolean {
    return this.controller.isLoading && Boolean(this.dataReschedulePickup)
  }

  public onPaginationPageInput(): void {
    void this.loadDetail(false)
  }

  public onPaginationPerPageChange(val: number): void {
    this.parameters.perPage = Number(val)
    void this.loadDetail(true)
  }

  private loadDetail(resetPage: boolean): void {
    if (!this.rescheduleId) return
    if (resetPage) {
      this.parameters.page = 1
    }
    try {
      controller.getDetailV2({
        id: this.rescheduleId,
        params: {
          page: this.parameters.page,
          perPage: this.parameters.perPage,
          sortField: this.parameters.sort.name,
          sortDirection: this.parameters.sort.direction,
          isShowDetail: this.isAllData,
        }
      })
    } catch (e) {
      const err = e as { status?: number; response?: { status?: number } }
      const st = err?.status ?? err?.response?.status
      if (st === 404) {
        void this.$router.replace({ name: 'ListPickupCRRNFD' })
      }
    }
  }

  private onToggleAllData(): void {
    this.isAllData = !this.isAllData
    void this.loadDetail(false)
  }

  public mapsHref(address: string): string {
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
      address || ''
    )}`
  }

  private onHandleOffline(): void {
    if (controller.isLoading) {
      controller.setLoading(false)
      this.showModal.confirm = false
      this.showModal.connection = true
    }
  }

  public waDigits(phone: string): string {
    return String(phone || '').replace(/\D/g, '')
  }

  public formatPhoneDisplay(phone: string): string {
    const raw = String(phone || '').trim()
    if (!raw) return ''
    const d = this.waDigits(raw)
    if (!d) return raw
    if (raw.startsWith('+')) return `+${d}`
    if (d.startsWith('62')) return `+${d}`
    if (d.startsWith('0')) return `+62${d.slice(1)}`
    return `+${d}`
  }


  public waSenderHref(phone: string): string {
    const d = this.waDigits(phone)
    const q = encodeURIComponent(
      'Hi Bapak/Ibu, kami ingin menghubungi terkait pickup Lion Parcel.'
    )
    return d ? `https://api.whatsapp.com/send?phone=${d}&text=${q}` : '#'
  }

  convertCurrencyRp(amount: number) {
    return `Rp${Utils.currencyDigit(amount)}`
  }

  private onShowImage(index: number): void {
    this.imageSrc = this.invoiceImage[index]
    this.showImage = true
    this.indexOfImage = index
  }

  @Watch('controller.dataReschedulePickupV2')
  onWatchDataReschedulePickupV2(data: ReschedulePickupDetailV2): void {
    this.dataReschedulePickup = data

    if (!data.proofUrls.length) {
      return
    } else if (data.proofUrls && data.proofUrls.length <= 4) {
      this.invoiceImage = data.proofUrls
    } else {
      this.invoiceImage = data.proofUrls.slice(0,4);
    }
  }

  @Watch('dataReschedulePickup', { deep: true })
  onDetailChange(): void {
    this.rebuildTable()

    const NextCourierLabel = this.buildNextCourierLine()
    const NextCourierAgentLabel = this.buildNextCourierAgent()

    if(NextCourierLabel && NextCourierAgentLabel) {
      this.form.courier = {
        label: `${NextCourierLabel} • ${NextCourierAgentLabel}`,
        value: this.dataReschedulePickup.courierId
      }
    }

    if(this.dataReschedulePickup.nextPickupDate && this.dataReschedulePickup.nextPickupTime) {
      const approvedDate = dayjs.utc(`${this.dataReschedulePickup.nextPickupDate} ${this.dataReschedulePickup.nextPickupTime}`).utcOffset(7).toDate()

      this.form.manualAssignDate = approvedDate
      this.form.manualAssignHour = approvedDate.getHours()
      this.form.manualAssignMinute = approvedDate.getMinutes()
    }

    if(this.dataReschedulePickup.statusApproval.toLocaleLowerCase() === "approved" || this.dataReschedulePickup.statusApproval.toLocaleLowerCase() === "rejected") {
      this.alreadySubmitted = true
    }
  }

  private headerCellMapper(
    title: string | number,
    colWidth: string,
    sortName?: string,
    sortWidth?: string
  ): HeaderObject {
    return {
      title: <string>title,
      customStyle: {
        minWidth: colWidth,
        maxWidth: colWidth,
      },
      withSort: Boolean(sortName),
      sortName: sortName,
      sortStyle: sortWidth ? { marginLeft: sortWidth } : {},
    }
  }

  private initHeaders(): void {
    this.headers = [
      this.headerCellMapper('No.', '56px'),
      this.headerCellMapper('Order ID', '160px'),
      this.headerCellMapper('Jenis Paket', '140px'),
      this.headerCellMapper('Total Koli', '100px')
    ]
  }

  private rebuildTable(): void {
    const d = this.dataReschedulePickup
    if (!d) {
      this.tableData = []
      return
    }
    const rows = d.shipments || []
    const offset = (this.parameters.page - 1) * this.parameters.perPage
    this.tableData = rows.map((row: ReschedulePickupDetailVShipment, index: number) => [
      this.tableCellMapper(String(offset + index + 1), '56px'),
      this.tableCellMapper({ shipmentId: row.shipmentId }, '160px'),
      this.tableCellMapper({ text: row.productType || '—' }, '140px'),
      this.tableCellMapper({ qty: row.totalColly }, '100px')
    ])
  }

  private tableCellMapper(value: unknown, colWidth: string): DataObject {
    const customStyle = {
      maxWidth: colWidth,
      minWidth: colWidth,
    }
    if (value !== null && typeof value === 'object' && !Array.isArray(value)) {
      const o = value as DataObject
      return {
        ...o,
        customStyle: { ...customStyle, ...o.customStyle },
      } as DataObject
    }
    return {
      value: value as DataObject['value'],
      customStyle,
    }
  }

  public onDataTableSort(val: SortValueObject): void {
    this.parameters.sort.name =  val.name || ""
    this.parameters.sort.direction = val.direction || ""
  }

  @Watch('controller.isApproved')
  onWatchErrorRequest(value: boolean): void {
    if (value) {
      this.showModal.success = true
      controller.setIsApproved(false)
    }
  }

  beforeDestroy(): void {
    window.removeEventListener('offline', this.onHandleOffline)
  }
}
